export function dateResolver(
  value: Date | string | number | undefined,
): number {
  return value === undefined
    ? 0
    : typeof value === 'number'
      ? value
      : value instanceof Date
        ? value.getTime()
        : new Date(value).getTime();
}
